export default class FiltroDocumentoComissao {
    constructor(){
        this.EmpresaId = undefined;
        this.FilialId = undefined;
        this.Tipo = undefined;
        this.PeriodoInicio = undefined;
        this.PeriodoFinal = undefined;
        this.RepresentanteId = undefined;
        this.TipoOrdenacao = 0;
        this.TipoComissaoTexto= undefined;
    }
}